import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr'
import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'
import pt from 'vuetify/es5/locale/pt'
import de from 'vuetify/es5/locale/de'
import it from 'vuetify/es5/locale/it'
import ro from 'vuetify/es5/locale/ro'

import { i18n } from '@/i18n'

Vue.use(Vuetify);

import MicrosoftAzureIcon from "@/components/icons/MicrosoftAzureIcon"

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#3366ff',
                info: '#41D3BD',
                error: '#DE6449',
                warning: '#EA7317',
                success: '#2E933C'
            }
        }
    },
    icons: {
        values: {
            "microsoft-azure": {
                component: MicrosoftAzureIcon
            }
        }
    },
    lang: {
        locales: { fr, en, es, pt, de, it, ro },
        current: i18n.locale
    },
});
